import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import {
  CofidisMonthlyApplicationFormValues,
  CofidisMonthlyApplicationValues,
} from './types'
import { CofidisMonthlyApplicationSchema } from './schema'

type UseCofidisApplicationFormArgs = {
  defaultValues?: CofidisMonthlyApplicationFormValues
}

const defaultFormValues: CofidisMonthlyApplicationFormValues = {
  editionMode: 'D',
  sustainableSupport: 'E',
}

export default function useCofidisApplicationForm(
  args: UseCofidisApplicationFormArgs = {}
) {
  const form = useForm<CofidisMonthlyApplicationFormValues, any, CofidisMonthlyApplicationFormValues>({
    mode: 'onBlur',
    shouldUnregister: false,
    defaultValues: {
      ...defaultFormValues,
      ...args.defaultValues,
    },
    // react-hook-form ≥7.55: zodResolver infers z.input<schema> as TFieldValues (not our Partial<>
    // form type), causing a Resolver generic mismatch. `as any` preserves pre-7.55 behavior —
    // Zod still validates and transforms at runtime. See docs/expo54-migration.md § Known Issues.
    resolver: zodResolver(CofidisMonthlyApplicationSchema) as any,
  })

  return form
}

export type CofidisApplicationForm = ReturnType<typeof useCofidisApplicationForm>
export type CofidisApplicationFormValues = CofidisMonthlyApplicationValues
